// src/ErrorBoundary.js
import React from 'react';
import { Var, T } from './lib/gt-shim';


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by boundary:", error);
    console.error("Component stack:", errorInfo.componentStack);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (<T id="errorboundary.1">
        <div style={{
          padding: '20px',
          textAlign: 'center',
          maxWidth: '800px',
          margin: '0 auto',
          marginTop: '50px',
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          color: '#333'
        }}>
          <h2>Something went wrong.</h2>
          <p>The application encountered an error. Please try refreshing the page.</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              backgroundColor: '#4285F4',
              color: 'white',
              border: 'none',
              padding: '10px 16px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              marginTop: '10px'
            }}>
            
            Refresh Page
          </button>
          
          {/* Debug information (only visible in development) */}
          <Var>{process.env.NODE_ENV === 'development' && (<T id="errorboundary.0">
              <div style={{ marginTop: '30px', textAlign: 'left' }}>
              <details>
                <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                  Error Details (for developers)
                </summary>
                <div style={{
                    marginTop: '10px',
                    padding: '15px',
                    backgroundColor: '#f5f5f5',
                    borderRadius: '4px',
                    overflow: 'auto',
                    maxHeight: '300px'
                  }}>
                  <h3>Error Message:</h3>
                  <pre style={{ color: '#d32f2f' }}><Var>{this.state.error && this.state.error.toString()}</Var></pre>
                  
                  <h3>Component Stack:</h3>
                  <pre style={{ color: '#333' }}><Var>{this.state.errorInfo && this.state.errorInfo.componentStack}</Var></pre>
                </div>
              </details>
            </div></T>
            )}</Var>
        </div></T>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;